import React from 'react';
import { Provider } from 'react-redux';
import { loadUser, OidcProvider } from 'redux-oidc';
import FeatureFlagProvider from './common/components/featureFlags/provider';
import { store } from './store/store';
import { userManager } from './userManager';

loadUser(store, userManager);

const Root = ({ children }: { children: JSX.Element }): JSX.Element => {
  return (
    <Provider store={store}>
      <OidcProvider userManager={userManager} store={store}>
        <FeatureFlagProvider>{children}</FeatureFlagProvider>
      </OidcProvider>
    </Provider>
  );
};

export default Root;
